import _ from "underscore";

/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import PropTypes from "prop-types";

import React from "react";
import classNames from "classnames";
import IconClass from "../elements/icon";
import BasicUtils from "../../utils/basic-utils";
const Icon = React.createFactory(IconClass);

// this.props.buttons should either be:
// an array of strings, which will be used as the label and the value of each button
// or
// objects with keys: [value (required), label, icon, disabled(bool), selected(bool)]
// can use 'label' or 'icon' or both
// 'disabled' can be used per button but the props.disabled == true will disable the entire control

export default class extends React.Component {
  static displayName = "Button Select";

  static propTypes = {
    buttons: PropTypes.array.isRequired,
    selected: PropTypes.any,
    large: PropTypes.bool,
    disabled: PropTypes.bool,
    onSelect: PropTypes.func.isRequired,
  };

  render() {
    return (
      <div className={classNames("et--button-select", this.props.className)}>
        {_.map(this.props.buttons, btn => {
          let disabled, gt_icon, icon, label, value;
          if (_.isString(btn)) {
            value = btn;
          } else {
            ({ value, label, icon, gt_icon, disabled } = btn);
          }

          const selected = BasicUtils.makeArray(this.props.selected);
          const enabled = !(this.props.disabled || disabled);
          const classes = classNames("et--button-select--item", {
            "is-disabled": !enabled,
            "is-selected": enabled && _.contains(selected, value),
            "is-large": this.props.large,
          });

          return (
            <span
              key={value}
              className={classes}
              onClick={enabled ? evt => this.props.onSelect(value, evt) : undefined}
            >
              {icon || gt_icon
                ? Icon({
                    className: "et--button-select--item-icon",
                    icon: icon || gt_icon,
                  })
                : undefined}
              {label ? <span className="et--button-select--item-label">{label}</span> : undefined}
            </span>
          );
        })}
      </div>
    );
  }
}
